import { EnvironmentType } from "@/types/EnvironmentType";

export function useEnvironment() {
  /**
   * The type of the current environment is based on the hostname.
   * If no hostname can be determined, the default is 'production'.
   * This allows us to turn off experimental features and avoid
   * reckless behavior on any environment whose type is unknown.
   */
  function getEnvironmentType(): EnvironmentType {
    const hostname =
      typeof window !== "undefined" ? window.location.hostname : "";

    if (hostname.match(/localhost/)) {
      return "development";
    } else if (hostname.match(/test/)) {
      return "test";
    } else if (hostname.match(/accept/)) {
      return "accept";
    } else {
      return "production";
    }
  }

  return { getEnvironmentType };
}
